import { render, staticRenderFns } from "./PageToGWatch.vue?vue&type=template&id=7d027ddd&scoped=true&"
import script from "./PageToGWatch.vue?vue&type=script&lang=js&"
export * from "./PageToGWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d027ddd",
  null
  
)

export default component.exports